export default __webpack_public_path__ + "static/media/change_phone.9b224c89.png";